import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Mic } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import VoiceRecordingModal from "./VoiceRecordingModal";

export default function VoiceCheckInWidget() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant="outline"
              size="icon"
              onClick={() => setIsModalOpen(true)}
              className="h-12 w-12 rounded-full bg-background/80 backdrop-blur-sm border-2 hover:bg-background/90 transition-all duration-200 shadow-lg"
              data-testid="voice-checkin-trigger"
            >
              <Mic className="h-5 w-5" />
              <span className="sr-only">Voice Check-in</span>
            </Button>
          </TooltipTrigger>
          <TooltipContent>
            <p>Voice Check-in</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>

      <VoiceRecordingModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
}
